module.exports = __webpack_public_path__ + "static/media/LS_3DSprite_ShouShou.0092.png.db1c0491.jpg";